
import React, { useEffect, useState } from "react";
import axios from "axios";
import hostlink from "../Hostlink/hostlink";
import { toast } from "react-toastify";

const EmployeeAdvance = () => {

    const user = JSON.parse(
        localStorage.getItem("MYPCKARTUSER") || "{}"
    );

    const shopid = localStorage.getItem('MYPCKARTUSER') ? JSON.parse(localStorage.getItem('MYPCKARTUSER'))[0].id : '0';

    const [employees, setEmployees] = useState([]);
    const [records, setRecords] = useState([]);
    const [selectedEmployee, setSelectedEmployee] = useState("");
    const [showModal, setShowModal] = useState(false);
    const [loading, setLoading] = useState(false);

    const [form, setForm] = useState({
        employeeid: "",
        type: "ADVANCE",
        amount: "",
        entrydate: new Date().toISOString().split("T")[0],
        narration: ""
    });

    useEffect(() => {
        if (shopid != 0) {
            loadEmployees();
        }

    }, [shopid]);

    const loadEmployees = async () => {

        try {

            const response = await axios.get(
                `${hostlink}/list/${shopid}`
            );

            setEmployees(response.data || []);

        } catch (error) {

            console.error(error);
            toast.error("Unable to load employees");
        }
    };

    const loadRecords = async (employeeid) => {

        if (!employeeid) {
            setRecords([]);
            return;
        }

        try {

            setLoading(true);

            const response = await axios.get(
                `${hostlink}/employee-advance/employee`,
                {
                    params: {
                        employeeid,
                        shopid
                    }
                }
            );

            setRecords(response.data || []);

        } catch (error) {

            console.error(error);
            toast.error("Unable to load advance records");

        } finally {
            setLoading(false);
        }
    };

    const handleEmployeeChange = e => {

        const employeeid = e.target.value;

        setSelectedEmployee(employeeid);
        loadRecords(employeeid);
    };

    const openAdvance = () => {

        setForm({
            employeeid: selectedEmployee,
            type: "ADVANCE",
            amount: "",
            entrydate: new Date().toISOString().split("T")[0],
            narration: ""
        });

        setShowModal(true);
    };

    const saveAdvance = async e => {

        e.preventDefault();

        if (!form.employeeid) {
            toast.error("Select employee");
            return;
        }

        if (!form.amount || Number(form.amount) <= 0) {
            toast.error("Enter valid amount");
            return;
        }

        try {

            const data = {
                employeeid: Number(form.employeeid),
                shopid,
                type: form.type,
                amount: Number(form.amount),
                entrydate: form.entrydate,
                narration: form.narration
            };

            await axios.post(
                `${hostlink}/employee-advance/save`,
                data
            );

            toast.success(
                form.type === "ADVANCE"
                    ? "Advance saved successfully"
                    : "Recovery saved successfully"
            );

            setShowModal(false);

            loadRecords(form.employeeid);

        } catch (error) {

            console.error(error);
            toast.error("Unable to save advance");
        }
    };

    const totalAdvance = records
        .filter(x => x.type === "ADVANCE")
        .reduce((sum, x) => sum + Number(x.amount || 0), 0);

    const totalRecovery = records
        .filter(x => x.type === "RECOVERY")
        .reduce((sum, x) => sum + Number(x.amount || 0), 0);

    const balance = totalAdvance - totalRecovery;

    const selectedName =
        employees.find(
            x => String(x.id) === String(selectedEmployee)
        )?.accname || "Select Employee";

    return (
        <div className="container-fluid py-3 advance-page">

            <div className="advance-header mb-3">

                <div className="header-title">

                    <div className="header-icon">
                        <i className="fa-solid fa-hand-holding-dollar"></i>
                    </div>

                    <div>
                        <h4>Employee Advance</h4>
                        <small>
                            Manage employee advances and recoveries
                        </small>
                    </div>

                </div>

                <button
                    className="btn btn-light"
                    onClick={openAdvance}
                    disabled={!selectedEmployee}
                >
                    <i className="fa-solid fa-plus me-2"></i>
                    New Entry
                </button>

            </div>


            <div className="filter-card mb-3">

                <label>Select Employee</label>

                <select
                    className="form-select"
                    value={selectedEmployee}
                    onChange={handleEmployeeChange}
                >
                    <option value="">
                        -- Select Employee --
                    </option>

                    {employees.map(employee => (
                        <option
                            key={employee.id}
                            value={employee.id}
                        >
                            {employee.accname}
                        </option>
                    ))}

                </select>

            </div>


            {selectedEmployee && (

                <>

                    <div className="row g-3 mb-3">

                        <div className="col-md-4">
                            <div className="amount-card">
                                <small>Total Advance</small>
                                <h3>
                                    ₹ {totalAdvance.toLocaleString("en-IN")}
                                </h3>
                            </div>
                        </div>

                        <div className="col-md-4">
                            <div className="amount-card">
                                <small>Total Recovery</small>
                                <h3>
                                    ₹ {totalRecovery.toLocaleString("en-IN")}
                                </h3>
                            </div>
                        </div>

                        <div className="col-md-4">
                            <div className="amount-card balance-card">
                                <small>Outstanding Balance</small>
                                <h3>
                                    ₹ {balance.toLocaleString("en-IN")}
                                </h3>
                            </div>
                        </div>

                    </div>


                    <div className="records-card">

                        <div className="records-header">

                            <div>
                                <h5>{selectedName}</h5>
                                <small>Advance History</small>
                            </div>

                            <button
                                className="btn btn-dark btn-sm"
                                onClick={openAdvance}
                            >
                                <i className="fa-solid fa-plus me-1"></i>
                                Add
                            </button>

                        </div>


                        <div className="table-responsive">

                            <table className="table modern-table mb-0">

                                <thead>
                                    <tr>
                                        <th>Date</th>
                                        <th>Type</th>
                                        <th>Narration</th>
                                        <th className="text-end">
                                            Amount
                                        </th>
                                    </tr>
                                </thead>

                                <tbody>

                                    {loading ? (

                                        <tr>
                                            <td
                                                colSpan="4"
                                                className="text-center py-5"
                                            >
                                                <div className="spinner-border"></div>
                                            </td>
                                        </tr>

                                    ) : records.length === 0 ? (

                                        <tr>
                                            <td
                                                colSpan="4"
                                                className="text-center py-5 text-muted"
                                            >
                                                No advance records found
                                            </td>
                                        </tr>

                                    ) : (

                                        records.map(record => (

                                            <tr key={record.id}>

                                                <td>
                                                    {record.entrydate}
                                                </td>

                                                <td>

                                                    <span
                                                        className={`type-badge ${record.type ===
                                                                "ADVANCE"
                                                                ? "advance"
                                                                : "recovery"
                                                            }`}
                                                    >
                                                        {record.type}
                                                    </span>

                                                </td>

                                                <td>
                                                    {record.narration || "-"}
                                                </td>

                                                <td className="text-end fw-bold">

                                                    ₹{" "}
                                                    {Number(
                                                        record.amount || 0
                                                    ).toLocaleString(
                                                        "en-IN"
                                                    )}

                                                </td>

                                            </tr>

                                        ))

                                    )}

                                </tbody>

                            </table>

                        </div>

                    </div>

                </>

            )}


            {showModal && (

                <div className="modal-backdrop-custom">

                    <div className="advance-modal">

                        <div className="modal-header-custom">

                            <div>
                                <h5>
                                    <i className="fa-solid fa-money-bill me-2"></i>
                                    Employee Advance
                                </h5>
                                <small>
                                    {selectedName}
                                </small>
                            </div>

                            <button
                                type="button"
                                className="btn-close"
                                onClick={() => setShowModal(false)}
                            ></button>

                        </div>


                        <form onSubmit={saveAdvance}>

                            <div className="modal-body-custom">

                                <div className="mb-3">

                                    <label>Transaction Type</label>

                                    <div className="type-selection">

                                        <button
                                            type="button"
                                            className={
                                                form.type === "ADVANCE"
                                                    ? "selected advance-select"
                                                    : ""
                                            }
                                            onClick={() =>
                                                setForm({
                                                    ...form,
                                                    type: "ADVANCE"
                                                })
                                            }
                                        >
                                            <i className="fa-solid fa-arrow-up"></i>
                                            Advance
                                        </button>

                                        <button
                                            type="button"
                                            className={
                                                form.type === "RECOVERY"
                                                    ? "selected recovery-select"
                                                    : ""
                                            }
                                            onClick={() =>
                                                setForm({
                                                    ...form,
                                                    type: "RECOVERY"
                                                })
                                            }
                                        >
                                            <i className="fa-solid fa-arrow-down"></i>
                                            Recovery
                                        </button>

                                    </div>

                                </div>


                                <div className="row g-3">

                                    <div className="col-md-6">

                                        <label>Date</label>

                                        <input
                                            type="date"
                                            className="form-control"
                                            value={form.entrydate}
                                            onChange={e =>
                                                setForm({
                                                    ...form,
                                                    entrydate:
                                                        e.target.value
                                                })
                                            }
                                        />

                                    </div>


                                    <div className="col-md-6">

                                        <label>Amount</label>

                                        <input
                                            type="number"
                                            min="0"
                                            step="0.01"
                                            className="form-control"
                                            placeholder="0.00"
                                            value={form.amount}
                                            onChange={e =>
                                                setForm({
                                                    ...form,
                                                    amount:
                                                        e.target.value
                                                })
                                            }
                                        />

                                    </div>

                                </div>


                                <div className="mt-3">

                                    <label>Narration</label>

                                    <textarea
                                        className="form-control"
                                        rows="3"
                                        placeholder="Enter narration..."
                                        value={form.narration}
                                        onChange={e =>
                                            setForm({
                                                ...form,
                                                narration:
                                                    e.target.value
                                            })
                                        }
                                    ></textarea>

                                </div>

                            </div>


                            <div className="modal-footer-custom">

                                <button
                                    type="button"
                                    className="btn btn-light"
                                    onClick={() =>
                                        setShowModal(false)
                                    }
                                >
                                    Cancel
                                </button>

                                <button
                                    type="submit"
                                    className="btn btn-dark px-4"
                                >
                                    <i className="fa-solid fa-check me-2"></i>
                                    Save Entry
                                </button>

                            </div>

                        </form>

                    </div>

                </div>

            )}


            <style>{`

                .advance-page {
                    min-height: 100vh;
                    background: #f5f7fb;
                }

                .advance-header {
                    padding: 20px 24px;
                    border-radius: 18px;
                    color: white;
                    background: linear-gradient(
                        135deg,
                        #151c2c,
                        #293f62
                    );
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                }

                .header-title {
                    display: flex;
                    align-items: center;
                    gap: 14px;
                }

                .header-icon {
                    width: 48px;
                    height: 48px;
                    border-radius: 14px;
                    background: rgba(255,255,255,.12);
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 21px;
                }

                .advance-header h4 {
                    margin: 0;
                    font-weight: 700;
                }

                .advance-header small {
                    opacity: .7;
                }

                .filter-card,
                .records-card {
                    background: white;
                    border-radius: 16px;
                    box-shadow: 0 5px 20px rgba(0,0,0,.05);
                }

                .filter-card {
                    padding: 18px;
                    max-width: 500px;
                }

                label {
                    font-size: 12px;
                    font-weight: 600;
                    color: #657083;
                    margin-bottom: 6px;
                }

                .amount-card {
                    background: white;
                    border-radius: 15px;
                    padding: 18px;
                    box-shadow: 0 5px 20px rgba(0,0,0,.05);
                    border-left: 4px solid #293f62;
                }

                .amount-card small {
                    color: #8a94a5;
                }

                .amount-card h3 {
                    margin: 6px 0 0;
                    font-weight: 800;
                }

                .balance-card {
                    border-left-color: #198754;
                }

                .records-header {
                    padding: 18px 20px;
                    border-bottom: 1px solid #edf0f4;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                }

                .records-header h5 {
                    margin: 0;
                    font-weight: 700;
                }

                .records-header small {
                    color: #8992a1;
                }

                .modern-table thead th {
                    background: #f8f9fb;
                    border: 0;
                    color: #697386;
                    font-size: 12px;
                    text-transform: uppercase;
                }

                .modern-table tbody td {
                    padding: 13px;
                    border-color: #f0f1f4;
                    vertical-align: middle;
                }

                .type-badge {
                    padding: 5px 9px;
                    border-radius: 20px;
                    font-size: 10px;
                    font-weight: 700;
                }

                .type-badge.advance {
                    background: #eaf8ef;
                    color: #198754;
                }

                .type-badge.recovery {
                    background: #fff1e8;
                    color: #d56b1f;
                }

                .modal-backdrop-custom {
                    position: fixed;
                    inset: 0;
                    background: rgba(15,20,30,.55);
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    z-index: 2000;
                    padding: 20px;
                }

                .advance-modal {
                    width: 100%;
                    max-width: 550px;
                    background: white;
                    border-radius: 18px;
                    overflow: hidden;
                    box-shadow: 0 20px 60px rgba(0,0,0,.25);
                }

                .modal-header-custom {
                    padding: 18px 20px;
                    background: #172033;
                    color: white;
                    display: flex;
                    justify-content: space-between;
                }

                .modal-header-custom h5 {
                    margin: 0;
                }

                .modal-header-custom small {
                    opacity: .65;
                }

                .modal-body-custom {
                    padding: 20px;
                }

                .modal-footer-custom {
                    padding: 15px 20px;
                    border-top: 1px solid #edf0f4;
                    display: flex;
                    justify-content: flex-end;
                    gap: 8px;
                }

                .type-selection {
                    display: flex;
                    gap: 10px;
                }

                .type-selection button {
                    flex: 1;
                    padding: 12px;
                    border: 1px solid #e0e4e9;
                    background: white;
                    border-radius: 10px;
                    color: #697386;
                }

                .type-selection button i {
                    margin-right: 8px;
                }

                .type-selection button.selected {
                    color: white;
                }

                .type-selection .advance-select {
                    background: #198754;
                    border-color: #198754;
                }

                .type-selection .recovery-select {
                    background: #d56b1f;
                    border-color: #d56b1f;
                }

            `}</style>

        </div>
    );
};

export default EmployeeAdvance;

